/**
 * Filter arrow component.
 */
import ArrowLeftIcon from '@components/atoms/icons/arrowLeft';
import { selectMagicRemoteEnabled } from '@shared/store/slices/magicRemote.slice';
import { useAppSelector } from '@shared/store/hooks';

/**
 * Filter arrow component.
 * Renders the filter arrow with an arrow left icon if the list index is greater than 1.
 */
export default function FilterArrow() {
  const enabled = useAppSelector(selectMagicRemoteEnabled);
  return !enabled ? <ArrowLeftIcon height={24} /> : null;
}
